import React, { useMemo, useState } from 'react'

import { Icon, Stack, colors as zetColors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import TextInput from '../textInput'
import Dropdown from './dropDown'

const SelectDropDown = ({
  label = 'Select Dropdown',
  placeholder = 'Select',
  onChange,
  onBlur,
  value,
  errorMessage,
  isRequired = true,
  dropdownMode = 'single',
  isSearchable = false,
  searchEndPoint,
  options,
  fieldId,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(
    toSentenceCase(value)
  )
  const [dropDownVisible, setDropDownVisible] = useState(false)
  const onDismiss = () => {
    setDropDownVisible(false)
  }

  const setOptionOnSelect = (val: string, displayText: string) => {
    if (isSearchable && !options?.find((item) => item.optionId === val)) {
      options?.push({
        optionId: val,
        optionValue: displayText,
      })
    }
  }

  function toSentenceCase(str) {
    if (label === 'Gender' && str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }
    return str
  }

  const onSelect = (val: string, displayText: string) => {
    setOptionOnSelect(toSentenceCase(val), toSentenceCase(displayText))
    setSelectedValue(toSentenceCase(val))
    onChange(toSentenceCase(val))
    onBlur()
  }

  const getDisplayText = useMemo(() => {
    const selectedObj = options?.find(
      (option) => option.optionId === selectedValue
    )
    return selectedObj?.optionValue ?? value
  }, [selectedValue])

  return (
    <Stack>
      <Pressable onPress={() => setDropDownVisible(true)}>
        <TextInput
          isEditable={false}
          placeholder={placeholder}
          onBlur={onBlur}
          iconRight={
            <Icon
              type="ArrowDown"
              color={zetColors.grays[80]}
              className="mr-1 mt-1"
            />
          }
          style={{
            color: zetColors.grays[100],
            fontFamily: 'Graphie-Book',
            margin: 0,
          }}
          value={
            dropdownMode === 'multi'
              ? selectedValue.toString().substring(0, 35)
              : toSentenceCase(getDisplayText)
          }
          label={label}
          isRequired={isRequired}
          errorMessage={errorMessage}
          disabled={false}
          pointerEvents="none"
        />
      </Pressable>
      <Dropdown
        label={label}
        dropdownMode={dropdownMode}
        isSearchable={isSearchable}
        onDismiss={onDismiss}
        selectedValue={selectedValue}
        setDropDownVisible={setDropDownVisible}
        dropDownVisible={dropDownVisible}
        searchEndPoint={searchEndPoint}
        options={options}
        fieldId={fieldId}
        onSelect={onSelect}
      />
    </Stack>
  )
}

export default SelectDropDown
